export const submitInfolettre = async (email) => {
	const data = {
		idWorkflow: 34707,
		wfKey: "hikKoS",
		nodeKey: "Optin",
		culture: "fr-CA",
		isDev: false,
		data: {
			record: {
				f_EMail: email,
				optin_Explicite_infolettreLio: true
			}
		}
	}

	try {
		const response = await fetch('https://app.dialoginsight.com/A/WF.ashx', {
			method: 'POST',
			headers: {
				'Content-Type': 'text/plain'
			},
			body: JSON.stringify(data)
		})
		const result = await response.json()
		if (result?.success) {
			return true
		} else {
			console.error(result)
			return false
		}
	} catch (error) {
		console.error(error)
		return false
	}
}

export const subscribeInfoletter = async() => {
	return await post('subscribeInfoLetter')
}